import { completeSubscriptionAPI } from './api';
import {
  animateInICSLink,
  animateInICSOutlook,
  animateInSuccess,
} from '../../animations/animate';

export function getCompleteSubscriptionParams (params) {
  const appStore = this.env.appStore;
  const statesStore = this.env.uiStatesStore;
  
  const widget = appStore.widget;
  const {
    id,
    user_type,
    calendar_type,
    calendar_ids,
  } = params;

  const ua = appStore.userAgent;
  const flags = appStore.flags;

  let source = 'web';
  if (!flags.embedded) {
    // ?? This field value is not as same as the V1.
    // It is "source": "email" in Apple and Outlook Classic Desktop
    source =  widget?.send_to_phone ? 'sms' : 'email';
  }

  const device = {
    user_agent: ua.ua,
    browser: ua.browser.name,
    os: ua.os.name,
    os_version: ua.os.version,
    type: flags.deviceType,
  };

  const body =  {
    id: [id],
    type: 'user',
    name: 'user_registration_completed',
    version: '1.1',
    calendar_type,
    emit_timestamp: new Date().toISOString(),
    emitter: {
      system: 'widgets',
      component: 'uniwidget',
    },
    keys: {
      user_ids: [id],
      widget_id: appStore.widget.id,
      publisher_id: appStore.widget.publisherId,
      calendar_ids,
    },
    data: {
      source,
      user_type,
      calendar_type,
      location: statesStore.subscribersParams.location,
      device,
    },
  };

  return body;
}

async function completeSubscription (params) {
    const env = this.env;
    const appStore = this.env.appStore;
    const apiKey = appStore.widgetSettings.apikey;
    const body = this.getCompleteSubscriptionParams(params);
    if (env.page?.params?.referringPage) {
      let refPage = env.page?.params?.referringPage;
      refPage = refPage.replaceAll('"', '');
      refPage = refPage.replaceAll(`'`, '');
      refPage = refPage.trim();
      body.data.referring_page = refPage;
    }

    // ensure that whatever it is in the state will not be processed.
    if (env.page?.params?.state) {
      body.state = env.page?.params?.state;
    }

    const res = await completeSubscriptionAPI({
        apiKey,
        body,    
        widgetId: appStore.widget.id,
        traceId: env.traceId,
        store: this,
    });

    // process res..
    console.log('completeSubscription() RESPONSE: -> ', appStore.selectedCalendar);
    // process ok complete subscriptions
    const {
      application,
    } = params;
    
    this.processCompleteSubscription(res, application);
}

export function processCompleteSubscription (res, application) {
  const appStore = this.env.appStore;
  console.log('processCompleteSubscription() res.data.statusLong ', res.data.statusLong);
  console.log('processCompleteSubscription() appStore.initializedAsInAppRedirect ', appStore.initializedAsInAppRedirect);
  
  if (res.data.statusLong === 'OK') {
    if ((appStore.selectedCalendar === 'google' ||
        appStore.selectedCalendar === 'windowslive' ||
        appStore.selectedCalendar === 'office365' ||
        appStore.selectedCalendar === 'android'
      )) {

      if (!appStore.initializedAsInAppRedirect) {
        animateInSuccess(this.env);
      } else {
        appStore.gotoSuccessInfoNoTransition();
      }
    }
    
    else if (appStore.selectedCalendar === 'ics_other') {
      animateInICSLink(this.env);
    }

    else if (appStore.selectedCalendar === 'outlook-new') {

      appStore.setSyncAction(() => {
        appStore.openDeviceCalendar(application);
        this.subscriberStatusPoll();
      });

      animateInICSOutlook(this.env);
    }

    else if ((!appStore.oauthSessionId && appStore.selectedCalendar !== 'ics_other') || 
      appStore.selectedCalendar === 'apple'
    ) {

      appStore.setSyncAction(() => {
        appStore.openDeviceCalendar(application);
        this.subscriberStatusPoll();
      });
      // check if ios safari if it is don't poll yet.

      appStore.openDeviceCalendar(application);
      // will only happen on apple calendar
      if (
          (appStore.flags.ios) ||
          (appStore.flags.ios && appStore.flags.isTwitter)
      ) {
        // wait till the page receive focus again before polling
        // delay polling 
        setTimeout(() => {
          this.subscriberStatusPoll();
        }, 3000);

        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) {
            console.log('processCompleteSubscription() will start polling in ios twitter');
            setTimeout(() => this.subscriberStatusPoll(), 1000);
          }     
        });

      } else {
        // immediately poll on desktop
        setTimeout(() => {
          this.subscriberStatusPoll();
        }, 3000);
      }
      
    }  
  }
}

export default completeSubscription;